import { lazy } from 'react';
const LtxTransitRec = lazy(() => import('./LtxTransitRec'));

const LtxTransitRecRoutes = [
  {
    path: '/ltxtransitrec',
    component: LtxTransitRec
  }
];

export default LtxTransitRecRoutes;
